<template>
  <div>
    <editable-chart-title v-if="printable" v-model="reportTitle"></editable-chart-title>
    <highcharts :options="options"></highcharts>
    <plot-line-legend-bar :plotLines="yAxisPlotLines" :hidden="hiddenPlotLines" @update:hidden="hiddenPlotLines = $event"></plot-line-legend-bar>
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import ExportingHighcharts from 'highcharts/modules/exporting';
import { Chart } from 'highcharts-vue';
import PlotLineLegendBar from './PlotLineLegendBar.vue';
import printableChart from './printableChart';

ExportingHighcharts(Highcharts);
export default {
  mixins: [printableChart],
  components: {
    highcharts: Chart,
    'plot-line-legend-bar': PlotLineLegendBar,
  },
  props: {
    title: String,
    series: Array,
    xAxisTitle: String,
    xAxisCategories: Array,
    yAxisTitle: String,
    yAxisPlotLines: Array,
  },
  watch: {
    title(val) {
      this.chartOptions.title.text = val;
    },
    series(val) {
      this.chartOptions.series = val;
    },
    yAxisTitle(val) {
      this.chartOptions.yAxis.title.text = val;
    },
    xAxisCategories(val) {
      this.chartOptions.xAxis.categories = val;
    },
    yAxisPlotLines(val) {
      this.chartOptions.yAxis.plotLines = val;
    },
  },
  computed: {
    visiblePlotLines() {
      return (this.yAxisPlotLines || []).filter((plotLine) => this.hiddenPlotLines.indexOf(plotLine.id) === -1);
    },
    options() {
      // The plot lines come from the legend bar state, not straight from the
      // prop. A hidden plot line stays hidden when the chart redraws.
      return this.applyPrintableTitle(
        Object.assign({}, this.chartOptions, {
          yAxis: Object.assign({}, this.chartOptions.yAxis, { plotLines: this.visiblePlotLines }),
        })
      );
    },
  },
  data() {
    const colors = Highcharts.getOptions().colors;
    return {
      hiddenPlotLines: [],
      chartOptions: {
        chart: {
          type: 'line',
          zoomType: 'x'
        },
        title: {
          text: this.title
        },
        xAxis: {
          title: {
            text: this.xAxisTitle
          },
          categories: this.xAxisCategories
        },
        yAxis: {
          title: {
            text: this.yAxisTitle
          },
          plotLines: this.yAxisPlotLines
        },
        legend: {
          verticalAlign: 'top',
        },
        credits: {
          enabled: false
        },
        tooltip: {
          shared: true,
        },
        series: this.series.map((value, index) => {
          return {
            name: value.name,
            data: value.data,
            color: colors[index],
            dataLabels: {
              enabled: true
            },
          }
        }),
      }
    };
  },
};
</script>